<template>
  <page-listado>
    <page-header title="Duraciones de Contrato">
      <b-button variant="primary" size="sm" to="/duracionesContrato/crear">
        <v-icon name="plus" width="16" />
        Crear duración de contrato
      </b-button>
    </page-header>
    <tabla :duraciones-contrato="duracionesContrato" />
  </page-listado>
</template>

<script>
import * as duracionesContratoApi from "@/services/duracionesContrato.js";
import Tabla from "./TablaDuracionesContrato.vue";
export default {
  components: { Tabla },
  data() {
    return {
      duracionesContrato: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async listar() {
      this.duracionesContrato = await duracionesContratoApi.listar(this.$route.query);
    },
  },
};
</script>
